<template>
    <div class="box dashboard-wave-background">
      <div class="modal-window" :class="{'open': are_your_details_up_to_date_popup_open }">
        <are-your-details-up-to-date-popup
            :logged_in_user="logged_in_user"
            :postcode_prefixes="postcode_prefixes"
            :selected_postcodes="selected_postcodes"
            :commercial_selected_postcodes="commercial_selected_postcodes"
            :company_showrooms="company_showrooms"
            :company_addresses="company_addresses"
            :epwin_system_types_for_company="epwin_system_types_for_company"
            :updated_user_details_required="updated_user_details_required"
            :updated_company_details_required="updated_company_details_required"
            @close="are_your_details_up_to_date_popup_open = false"
        ></are-your-details-up-to-date-popup>
      </div>
        <div class="modal-window" :class="{'open': add_lead_recipients_popup_open }">
            <add-lead-recipients-popup
                :logged_in_user="logged_in_user"
                @close="add_lead_recipients_popup_open = false"
            ></add-lead-recipients-popup>
        </div>
      <div class="modal-window" :class="{'open': book_a_factory_tour_form_open}" @click="book_a_factory_tour_form_open = false">
        <div class="modal-window-inner" @click.stop>
          <div class="modal-close" @click.stop="book_a_factory_tour_form_open = false">
            <i class="fal fa-times"></i>
          </div>
          <div class="modal-header">
            <h1 class="modal-title">Book a Factory Tour</h1>
          </div>
          <div class="modal-content">
            <div class="form-group">
              Please fill out the form below and somebody will get back to you to confirm your booking.
            </div>
            <div class="form-group">
              <label>Contact Name</label>
              <input type="text" class="form-control" v-model="factory_tour_enquiry_name">
            </div>
            <div class="form-group">
              <label>Contact Email</label>
              <input type="email" class="form-control" v-model="factory_tour_enquiry_email">
            </div>
            <div class="form-group">
              <label>Contact Phone</label>
              <input type="text" class="form-control" v-model="factory_tour_enquiry_phone">
            </div>
            <div class="form-group">
              <label>Additional Information</label>
              <em class="txt-sm txt-light">
                Please let us know what dates you are available and the names of colleagues who would be attending.
              </em>
              <textarea rows="5" v-model="factory_tour_enquiry_message" class="form-control"></textarea>
            </div>
          </div>
          <div class="modal-footer align-right">
            <a class="btn-primary" @click="sendfactoryTourEnquiry()">
              Send
            </a>
          </div>
        </div>
      </div>
      <div class="modal-window" :class="{'open': what_would_you_like_to_see_enquiry_box_open}" @click="what_would_you_like_to_see_enquiry_box_open = false">
        <div class="modal-window-inner" @click.stop>
          <div class="modal-close" @click.stop="what_would_you_like_to_see_enquiry_box_open = false">
            <i class="fal fa-times"></i>
          </div>
          <div class="modal-header">
            <h1 class="modal-title">What would you like to see on Connect?</h1>
          </div>
          <div class="modal-content">
            <div class="form-group">
              Please enter details of your request below.
            </div>
            <textarea rows="5" v-model="what_would_you_like_to_see_enquiry_message" class="form-control"></textarea>
          </div>
          <div class="modal-footer align-right">
            <a class="btn-primary" @click="sendWhatWouldYouLikeToSeeEnquiry()">
              Send
            </a>
          </div>
        </div>
      </div>
      <div class="modal-window" :class="{'open': app_tile_instructions_box_open}" @click="app_tile_instructions_box_open = false">
        <div class="modal-window-inner" @click.stop>
          <div class="modal-close" @click.stop="app_tile_instructions_box_open = false">
            <i class="fal fa-times"></i>
          </div>
          <div class="modal-header">
            <h1 class="modal-title">Add Connect to your home page</h1>
          </div>
          <div class="modal-content">
            <div class="flex-xs">
              <div class="half-width-xs">
                <img src="/images/dashboard_add_app_tile_ios.png">
              </div>
              <div class="half-width-xs">
                <img src="/images/dashboard_add_app_tile_android.png">
              </div>
            </div>
          </div>
        </div>
      </div>

      <dashboard-promotional-panel
        :promotional_slides="promotional_slides"
      ></dashboard-promotional-panel>

      <div class="dashboard-buttons">
        <div class="dashboard-button">
          <a @click="clickedUserGuideLink" href="/documents/fabricator_user_guide.pdf" class="btn-primary" target="_blank" v-if="logged_in_user.isFabricator || logged_in_user.isTrial">
            User Guide <i class="fa-light fa-download ml-1"></i>
          </a>
          <a @click="clickedUserGuideLink" href="/documents/installer_user_guide.pdf" class="btn-primary" target="_blank" v-else>
            User Guide <i class="fa-light fa-download ml-1"></i>
          </a>
        </div>
        <div class="dashboard-button">
          <a class="btn-primary" @click.stop.prevent="app_tile_instructions_box_open = true">
            Add Connect to your home page <i class="fa-light fa-house-blank ml-1"></i>
          </a>
        </div>
        <div class="dashboard-button">
          <a class="btn-primary" @click.stop.prevent="what_would_you_like_to_see_enquiry_box_open = true">
            Got a suggestion? <i class="fa-light fa-messages-question ml-1"></i>
          </a>
        </div>
        <div class="dashboard-button">
          <a class="btn-primary" @click.stop.prevent="book_a_factory_tour_form_open = true">
            Book a Factory Tour <i class="fa-light fa-industry ml-1"></i>
          </a>
        </div>
        <div class="dashboard-button">
          <a href="/faqs" class="btn-primary" target="_blank">
            FAQ's <i class="fa-light fa-question ml-1"></i>
          </a>
        </div>
      </div>

      <epwin-system-types-dashboard-slider
        :epwin_system_types="epwin_system_types_for_slider"
        :logged_in_user="logged_in_user"
      ></epwin-system-types-dashboard-slider>

      <div class="dashboard-installation-showcase-and-project-snapshot">
        <div class="dashboard-installation-showcase-wrapper">
          <div class="dashboard-installation-showcase">
            <h1>Win £1000 Marketing Support!</h1>
            <div>
              <img src="/images/dashboard-installation-showcase-hero-shot.jpg">
            </div>
            <p>
              Enter your most impressive installations for a chance to win £1000 in marketing support. There’s a top prize every month, plus £250 for runners-up - and you can enter as often as you like.
            </p>
            <p>
              You could use your prize to elevate your showroom with premium brochures and promo items. Or kit out your team with custom clothing and van graphics.
            </p>
            <p>
              What's more, selected entries will also receive a professional photoshoot to showcase their work in style!
            </p>
            <div class="m-3">
              <a class="btn-primary-outline _lg full-width" href="/installation-of-the-month">Enter Now</a>
            </div>
          </div>
        </div>
        <div class="dashboard-project-snapshot-wrapper">
          <div class="dashboard-project-snapshot">
            <h1>Project Snapshot</h1>
            <div>
              <img src="/images/dashboard-project-snapshot-hero-shot.jpg">
            </div>
              <p>
                  It's time to promote your work!
              </p>
              <p>
                  Submit details of your most outstanding commercial projects and we'll take care of the rest.
              </p>
              <p>
                  Our PR team will create a full case study ready to be published to fenestration magazines.
              </p>
              <div class="m-3">
                <a class="btn-primary _lg full-width" v-if="has_snapshot_section_access" href="/commercial/case-studies">Submit Case Study</a>
                <a class="btn-primary _lg full-width" v-else href="/commercial">Find Out More</a>
              </div>
          </div>
        </div>
      </div>

      <latest-news
          :news_posts="news_posts"
      ></latest-news>

      <testimonials-slider></testimonials-slider>

    </div>
</template>

<script>
  import OffersAndPromotionsSlider from './OffersAndPromotionsSlider.vue';
  import InstallationOfTheMonth from './InstallationOfTheMonth.vue';
  import LatestNews from './LatestNews.vue';
  import vue2Dropzone from "vue2-dropzone";
  import AreYourDetailsUpToDatePopup from "./AreYourDetailsUpToDate.vue";
  import TestimonialsSlider from "./TestimonialsSlider.vue";
  import EpwinSystemTypesDashboardSlider from "./EpwinSystemTypesDashboardSlider";
  import DashboardPromotionalPanel from "./DashboardPromotionalPanel.vue";
  import AddLeadRecipientsPopup from "./AddLeadRecipientsPopup.vue";

  export default {
    props: [
      'logged_in_user',
      'news_posts',
      'notification_count',
      'enquiry_count',
      'aws_policy',
      'aws_credential',
      'aws_date',
      'aws_signature',
      'updated_user_details_required',
      'updated_company_details_required',
      'postcode_prefixes',
      'selected_postcodes',
      'commercial_selected_postcodes',
      'company_showrooms',
      'company_addresses',
      'epwin_system_types_for_company',
      'epwin_system_types_for_slider',
      'show_trusted_device_notice',
      'promotional_slides',
      'has_snapshot_section_access',
      'lead_recipients_required',
    ],
    data() {
      return {
        what_would_you_like_to_see_enquiry_box_open: false,
        what_would_you_like_to_see_enquiry_message: '',
        sending_what_would_you_like_to_see_enquiry: false,
        are_your_details_up_to_date_popup_open: false,
        add_lead_recipients_popup_open: false,
        is_mobile: false,
        app_tile_instructions_box_open: false,
        book_a_factory_tour_form_open: false,
        factory_tour_enquiry_message: '',
        sending_factory_tour_enquiry: false,
        factory_tour_enquiry_name: '',
        factory_tour_enquiry_email: '',
        factory_tour_enquiry_phone: '',
      }
    },
    components: {
      'are-your-details-up-to-date-popup': AreYourDetailsUpToDatePopup,
      'add-lead-recipients-popup': AddLeadRecipientsPopup,
      'offers-and-promotions-slider': OffersAndPromotionsSlider,
      'installation-of-the-month': InstallationOfTheMonth,
      'latest-news': LatestNews,
      'vue-dropzone': vue2Dropzone,
      'testimonials-slider' : TestimonialsSlider,
      'epwin-system-types-dashboard-slider' : EpwinSystemTypesDashboardSlider,
      'dashboard-promotional-panel': DashboardPromotionalPanel,
    },
    mounted() {

      let isMobile = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) isMobile = true;})(navigator.userAgent||navigator.vendor||window.opera);
      this.is_mobile = isMobile;

      if(this.updated_user_details_required || this.updated_company_details_required) {
        this.are_your_details_up_to_date_popup_open = true;
      }

      if(this.lead_recipients_required) {
          this.add_lead_recipients_popup_open = true;
      }

    },
    methods: {
      openLiveChat() {
        LiveChatWidget.call('maximize');
      },
      openNotificationSidebar() {
        EventBus.$emit('toggle-notification-sidebar');
      },
      openSearchBar() {
        EventBus.$emit('toggle-searchbar');
      },
      sendWhatWouldYouLikeToSeeEnquiry() {

        if(this.what_would_you_like_to_see_enquiry_message === '') {
          Swal.fire({
            title: 'Please enter a message',
            icon: 'error',
          });
          return;
        }

        this.what_would_you_like_to_see_enquiry_box_open = false;
        this.sending_what_would_you_like_to_see_enquiry = true;
        axios.post('/enquiry/send', {
          'enquiry_type_id': 27,
          'message': this.what_would_you_like_to_see_enquiry_message,
        }).then((response) => {

          gtag('event', 'enquiry_made', {
            'event_category': 'enquiries',
            'event_label': 'What would you like to see enquiry',
            'value': 'What would you like to see enquiry',
          });

          this.sending_what_would_you_like_to_see_enquiry = false;
          Swal.fire({
            title: 'Message Sent',
            icon: 'success',
            text: 'Your message has been sent, you will be sent a notification when you receive a reply.'
          });
        });
      },
      sendfactoryTourEnquiry() {

        if(this.factory_tour_enquiry_name === '' || this.factory_tour_enquiry_phone === '' || this.factory_tour_enquiry_email === '' || this.factory_tour_enquiry_message === '') {
          Swal.fire({
            title: 'Please fill out all fields',
            icon: 'error',
          });
          return;
        }

        this.book_a_factory_tour_form_open = false;
        this.sending_factory_tour_enquiry = true;

        const formattedMessage = `Name: ${this.factory_tour_enquiry_name}\n` +
          `Phone: ${this.factory_tour_enquiry_phone}\n` +
          `Email: ${this.factory_tour_enquiry_email}\n\n` +
          `Message:\n${this.factory_tour_enquiry_message}`;

        axios.post('/enquiry/send', {
          'enquiry_type_id': 55,
          'message': formattedMessage,
        }).then((response) => {

          gtag('event', 'enquiry_made', {
            'event_category': 'enquiries',
            'event_label': 'Factory Tour enquiry',
            'value': 'Factory Tour enquiry',
          });

          this.sending_factory_tour_enquiry = false;
          Swal.fire({
            title: 'Message Sent',
            icon: 'success',
            text: 'Your message has been sent, you will be sent a notification when you receive a reply.'
          });
        });
      },
      clickedUserGuideLink() {
          axios.post('/activity-logs/createActivityLogFromRequest', {
              'activity_log_category_id': 1,
              'description': `User Guide Downloaded`,
          });
      },
    },
  }
</script>
